module.exports = __webpack_public_path__ + "public/img/up-gif.2e388b64.gif";